/**
 * Takes an array of keys, and turns it into an object mapping keys to themselves.
 * When the first argument is an array, we assume there is no namespace and use the
 * arg2 as the keys array.
 *
 * -@param  {String} arg1 Optional key namespace.
 * -@param  {Array}  arg2 The keys to convert into object.
 * -@return {Object}      Resulting key indexed object.
 */
export default function keyMirror(arg1, arg2) {
    const { keys, namespace } = arg1 instanceof Array
        ? { keys: arg1 }
        : { keys: arg2, namespace: arg1 };

    return keys.reduce((map, key) => {
        map[key] = namespace !== undefined
            ? `${namespace}.${key}`
            : key;
        return map;
    }, {});
}
